import axios, { AxiosResponse } from 'axios'
import { env } from '@js/utils/env'

import gql from '@js/api/utils/gql'
import getBearerToken from '@js/api/utils/getBearerToken'
import getStoreName from '@js/api/utils/getStoreName'

export const applyStoreCreditMutation = gql`
  mutation applyStoreCreditToCart($cartId: String!) {
    applyStoreCreditToCart(input: {
      cart_id: $cartId
    }) {
      cart {
        id
        applied_store_credit {
          applied_balance {
            value
            currency
          }
          current_balance {
            value
            currency
          }
        }
        prices {
          grand_total {
            value
            currency
          }
          discounts {
            label
            amount {
              value
              currency
            }
          }
        }
      }
    }
  }
`

interface ApplyStoreCreditResponse {
  data: {
    applyStoreCreditToCart: {
      cart: any
    }
  }
  errors?: { message: string }[]
}

export async function applyStoreCredit(cartId: string) {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<ApplyStoreCreditResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: applyStoreCreditMutation,
      variables: { cartId },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.applyStoreCreditToCart.cart
}
